import axios from "axios";

const baseURL = window.location.hostname === "localhost" ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

export function errMsg(e, fallback = "Terjadi kesalahan. Coba lagi.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

export async function downloadFile(path, filename, mime = "application/pdf") {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: mime }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const downloadPdf = (path, filename) => downloadFile(path, filename);
